import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAccessToken } from '@/app/hooks/auth-provider';

const baseQuery = fetchBaseQuery({
  baseUrl: `${import.meta.env.VITE_BASE_API_URL}/api`,
  prepareHeaders: headers => {
    headers.append('Authorization', `Bearer ${getAccessToken()}`);
    return headers;
  },
});
export enum CacheTag {
  Account = 'account',
  User = 'user',
  Events = 'events',
  CurrentUser = 'currentUser',
  AccountReps = 'accountReps',
  NotificationSubscriptions = 'notificationSubscriptions',
  NotificationMessages = 'notificationMessages',
  Chat = 'chat',
  OnboardImport = 'onboardImport',
  Organization = 'organization',
}

export default createApi({
  reducerPath: 'api',
  baseQuery: baseQuery,
  tagTypes: [
    CacheTag.Account,
    CacheTag.User,
    CacheTag.Events,
    CacheTag.CurrentUser,
    CacheTag.AccountReps,
    CacheTag.NotificationSubscriptions,
    CacheTag.NotificationMessages,
    CacheTag.Chat,
    CacheTag.OnboardImport,
    CacheTag.Organization,
  ],
  endpoints: () => ({}),
});
